/**
 * Persistencia de la sesion en `sessionStorage` (no localStorage):
 * desaparece al cerrar la pestaña, lo cual es razonable para una app
 * de auditores que comparten dispositivos.
 *
 * En Sprint 4 (offline-first) la persistencia migra a IndexedDB cifrada
 * con clave derivada del password (PRD seccion 6 + ADR-002).
 */
import type { AuthUser } from '../api/auth.js';

const KEY = 'assessos.auth.session';

export interface AuthSession {
  token: string;
  kind: 'temp' | 'full';
  expiresAt: string;
  mfaStatus?: 'setup_required' | 'configured';
  user?: AuthUser;
}

export function loadSession(): AuthSession | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as AuthSession;
    if (!parsed.token || !parsed.kind || !parsed.expiresAt) return null;
    if (new Date(parsed.expiresAt).getTime() <= Date.now()) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveSession(session: AuthSession): void {
  sessionStorage.setItem(KEY, JSON.stringify(session));
}

export function clearSession(): void {
  sessionStorage.removeItem(KEY);
}
